export default __webpack_public_path__ + "7274e74c05adf47dbcd99b87fc1f2a60.woff";